import React from 'react';
import { Anchor } from 'antd';

import style from './index.less';

const { Link } = Anchor;

type NavItem = {
  label: string;
  value: string | number;
};

type ClientAnchorProps = {
  scrollContainer?: HTMLDivElement | null;
  nav: NavItem[];
};
const ClientAnchor = ({ scrollContainer, nav }: ClientAnchorProps): JSX.Element => {
  const scrollContainerProps = scrollContainer ? { getContainer: () => scrollContainer } : undefined;
  return (
    <Anchor affix={false} className={style.anchor} {...scrollContainerProps}>
      {nav.map(val => {
        const { label, value } = val;
        return <Link href={`#${value}`} title={label} key={value} />;
      })}
    </Anchor>
  );
};

export default ClientAnchor;
